<div class="container-fluid mt-3 mb-5">
  <div class="container">
    <div class="row">
      <div class="col">
        <c11n-internal-callout [variant]="isSmallScreen?'vertical': 'horizontal'" [headingLevel]="2">
          <p class="c11n-text-md-bold">{{ content?.crewOnlyMessage || 'This page is for crew only. Clients cannot view this page.' }}</p>
        </c11n-internal-callout>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row">
      <div class="col-md-8 col-lg-8 m-auto">
        <div class="process-flow-pattern__content-header">
            <span
              class="default__family-font d-none d-sm-block c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"
              tabindex="-1"
              #title
            >{{ content?.sendDuplicateConfirmationLabel || 'Send duplicate confirmation' }}</span>
          <span class="d-block d-sm-none c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"></span>

          <c11n-button
            [size]="'small'"
            [labelText]="'Quit'"
            [variant]="'ghost'"
            [iconPosition]="'trailing'"
            (clickEvent)="onCancel()"
            iconName="remove"
            class="process-flow-pattern__quit-btn"
          >
          </c11n-button>
        </div>
        <section class="c11n-space-stack-6x">
          <div class="mb-1 process-flow-pattern__content-heading d-block d-sm-none">
            <span
              class="default__family-font c11n-text-sm c11n-space-stack-1x process-flow-pattern__content-heading"
              tabindex="-1"
              #title
            >{{ content?.sendDuplicateConfirmationLabel || 'Send duplicate confirmation' }}</span>
          </div>
          <div class="c11n-text-sm-bold c11n-space-stack-2x">
            {{ getStepText(3) }}
          </div>
          <app-step-indicator
            [isSmallScreen]="isSmallScreen"
            [currentStep]="(currentStepIndicatorIndex$ | async) || 3"
            [stepLabels]="[
              content?.stepLabels?.selectRecipient || 'Select recipient',
              content?.stepLabels?.reviewSubmit || 'Review & submit',
              content?.stepLabels?.confirmation || 'Confirmation'
            ]">
          </app-step-indicator>
        </section>

        <section role="region" aria-label="Statement Details">
          <header class="statement-details-left send-duplicate__headers">
            <h2 class="main-title mb-2">{{ content?.headers?.confirmation || 'Confirmation' }}</h2>
            <p class="confirmation-message c11n-text-md">
              {{ content?.descriptions?.confirmationSubmitted || 'Your duplicate confirmation request has been submitted.' }}
            </p>
          </header>

          <!-- Statement Details -->
          <ng-container *ngIf="recipient$ | async as recipient">
            <dl class="details-grid">
              <div class="detail-row">
                <dt class="label c11n-text-md-bold"><strong>{{ content?.tableLabels?.confirmationDate || 'Confirmation date' }}</strong></dt>
                <dd class="value c11n-text-md">{{ recipient.confirmationDate }}</dd>
              </div>
              <div class="detail-row">
                <dt class="label c11n-text-md-bold"><strong>{{ content?.tableLabels?.account || 'Account' }}</strong></dt>
                <dd class="value c11n-text-md">{{ recipient.description }}</dd>
              </div>
            </dl>

            <dl class="p-3 recipient__container">
              <dt class="label c11n-text-md-bold"><strong>{{ content?.tableLabels?.recipient || 'Recipient' }}</strong></dt>
              <dd class="value c11n-text-md">
                <div class=" c11n-text-md default__family-font">{{ recipient.name }}</div>
                <div class=" c11n-text-md default__family-font">{{ recipient.address }}</div>
              </dd>
            </dl>
          </ng-container>
        </section>

        <!-- Action Button -->
        <div class="button-group mb-5">
          <c11n-button
            buttonType="button"
            [size]="'medium'"
            variant="primary"
            [labelText]="content?.buttons?.backToConfirmations || 'Back to confirmations'"
            iconName=""
            [title]="content?.buttons?.backToConfirmations || 'Back to confirmations'"
            colorMode="on-light"
            [href]="'/'">
          </c11n-button>
        </div>
      </div>
    </div>
  </div>
</div>
